import React from 'react'
import styled from 'styled-components'
import FadeToggle, { MoveLeft } from './FadeToggle'
import Icon from './Icon'

export type OverlaySideWindowProps = React.PropsWithChildren<{
  visible?: boolean
  close?: () => unknown
  title?: string
  currentKey?: string
}>

const Wrap = styled(MoveLeft)`
  position: absolute;
  right: 40px;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1199px) {
    right: 20px;
  }
`

const ContentWrap = styled.div`
  background: #fff;
  padding: 20px;
  width: 350px;
  pointer-events: all;
  padding-bottom: 10px;
  position: relative;
`

const OverlaySideindowTitle = styled.b`
  text-transform: uppercase;
  display: block;
  margin-bottom: 5px;
  font-size: 20px;
  margin-bottom: 10px;
`

const CloseButton = styled.button.attrs({
  className: 'button button--icon',
  children: <Icon name="remove" />
})`
  position: absolute;
  top: 7px;
  right: 7px;
`

const OverlaySideWindow: React.FC<OverlaySideWindowProps> = ({ visible, title, children, currentKey, close }) => {
  return (
    <FadeToggle visible={visible} currentKey={currentKey}>
      <Wrap>
        <ContentWrap data-cs-ignore-close="moduleProperties">
          {!!title && <OverlaySideindowTitle>{title}</OverlaySideindowTitle>}
          {children}
          {!!close && <CloseButton onClick={close} />}
        </ContentWrap>
      </Wrap>
    </FadeToggle>
  )
}

export default OverlaySideWindow
